import Vue from 'vue'
import it from './it'
import en from './en'

const messages = { it, en }

const state = Vue.observable({
	locale: localStorage.getItem('lang') || 'it',
})

const searchTranslation = {
	install(Vue) {
		Vue.prototype.$lang = state

		Vue.prototype.$t = function (key) {
			const keys = key.split('.')
			let value = messages[state.locale]

			for (const k of keys) {
				value = value?.[k]
			}

			return value ?? key
		}

		Vue.prototype.$setLang = function (locale) {
			state.locale = locale
			localStorage.setItem('lang', locale)
		}
	},
}

export default searchTranslation
